module.exports = __webpack_public_path__ + "static/img/przybornik_wielkosc5.bda2ce87.png";